import { BATCH_STATUS_OPTIONS } from '../../domain/enrollment/constants';
import { getPrimaryEnrollment } from '../../utils/studentEnrollmentStatus';
import SearchableSelect from '../Form/SearchableSelect';

const EnrollmentStatusControl = ({
  student,
  onStatusChange,
  disabled = false,
  updating = false,
  compact = false,
}) => {
  const enrollment = getPrimaryEnrollment(student);
  const batchLabel = enrollment?.batch?.batchName;
  const courseLabel = enrollment?.batch?.course?.courseName;

  if (!enrollment?.id) {
    return (
      <span className="text-xs text-gray-400" title="No enrollment to update">
        No enrollment
      </span>
    );
  }

  const title = [batchLabel, courseLabel].filter(Boolean).join(' · ') || 'Update student status';

  return (
    <div
      className={compact ? 'min-w-[120px]' : 'flex flex-col gap-0.5 min-w-[140px]'}
      onClick={(e) => e.stopPropagation()}
    >
      {!compact && (
        <label className="text-[10px] uppercase tracking-wide text-gray-500 font-medium">
          Status
        </label>
      )}
      <SearchableSelect
        value={enrollment.batchStatus || 'Ongoing'}
        disabled={disabled || updating}
        aria-label={title}
        onChange={(e) => onStatusChange(student, enrollment, e.target.value)}
        className="w-full"
        placeholder="Status"
        options={BATCH_STATUS_OPTIONS}
        required
      />
      {!compact && (batchLabel || updating) && (
        <span className="text-[10px] text-gray-500 truncate max-w-[180px]" title={title}>
          {updating ? 'Saving…' : batchLabel}
        </span>
      )}
      {compact && updating && (
        <span className="text-[10px] text-gray-500">Saving…</span>
      )}
    </div>
  );
};

export default EnrollmentStatusControl;
